module.exports = __webpack_public_path__ + "img/metaPayDisable.aba7d925.svg";